import React from 'react';
import { View, Pressable, Text, StyleSheet } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

import { InfoIconV2 } from '../resources/svgComponents/InfoIconV2';

type THowToPlayButtonProps = {
  onPress: () => void;
};

export default function HowToPlayButton(props: THowToPlayButtonProps) {
  const { onPress } = props;
  return (
    <LinearGradient
      colors={['rgba(255, 207, 83, 0.55)', 'rgba(255, 153, 0, 0.55)']}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
      style={styles.gradientBorder}
    >
      <View style={[styles.innerContainer]}>
        <Pressable onPress={onPress} style={[styles.btnContainer]}>
          <View style={[styles.activeTextContainer]}>
            <Text maxFontSizeMultiplier={1} style={[styles.activeText]}>
              {'How to Play'}
            </Text>
            <View style={[styles.lockIcon]}>
              <InfoIconV2 />
            </View>
          </View>
        </Pressable>
      </View>
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  gradientBorder: {
    borderRadius: 16,
    padding: 1.5,
    height: 60,
  },
  innerContainer: {
    borderRadius: 14,
    backgroundColor: '#FFF8E3',
    overflow: 'hidden',
  },
  btnContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
  },

  activeTextContainer: {
    height: 54,
    width: 206,
    justifyContent: 'center',
    marginLeft: 8,
    borderRadius: 16,
    backgroundColor: '#FFFFFF',
    opacity: 0.8,
  },
  activeText: {
    fontFamily: 'Secular One',
    fontSize: 22,
    fontWeight: '400',
    color: '#453B3B',
    paddingVertical: 3,
    paddingHorizontal: 12,
  },
  lockIcon: {
    position: 'absolute',
    right: 8,
  },
});
